export const SAVING_EMAIL_TEMPLATES = 'Saving Email Templates';
export const RETRIEVING_EMAIL_TEMPLATES = 'Retrieving Email Templates';
export const SENDING_TEST_EMAIL_TEMPLATE = 'Sending Test Email Template';
